import { fmtHours, fmtMoney } from "@/lib/calc";
import { Clock, DollarSign, CalendarDays, Flame } from "lucide-react";

const ICONS = { "weekly-hours": Clock, "weekly-earnings": DollarSign, "monthly-hours": CalendarDays, "monthly-earnings": Flame };

function KpiCard({ id, title, subtitle, value, accent, Icon }) {
  const accentColor = accent === "emerald" ? "#10b981" : "#f59e0b";
  const glow = accent === "emerald" ? "0 4px 28px rgba(16,185,129,0.07)" : "0 4px 28px rgba(245,158,11,0.07)";
  return (
    <div
      data-testid={`kpi-${id}`}
      className="relative bg-[#181a22] border border-[#2b2f3d] rounded-xl p-5 overflow-hidden transition-colors hover:border-[#3a3f52] fade-up"
      style={{ boxShadow: glow }}
    >
      <div className="flex items-start justify-between">
        <span className="font-mono-data text-[11px] uppercase tracking-[0.18em] text-[#62697e]">{title}</span>
        <Icon className="w-4 h-4" style={{ color: accentColor }} />
      </div>
      <div className="mt-3 font-mono-data font-bold tracking-tight text-3xl sm:text-4xl" style={{ color: accentColor }}>
        {value}
      </div>
      <div className="mt-1.5 text-xs text-[#9fa6b9]">{subtitle}</div>
    </div>
  );
}

export default function KpiRibbon({ stats, currency }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <KpiCard id="weekly-hours" title="This Week Overtime" subtitle="Current week (Mon–Sun)" value={fmtHours(stats.weekHours)} accent="amber" Icon={ICONS["weekly-hours"]} />
      <KpiCard id="weekly-earnings" title="Weekly Overtime Pay" subtitle="Estimated gross payout" value={fmtMoney(stats.weekEarnings, currency)} accent="emerald" Icon={ICONS["weekly-earnings"]} />
      <KpiCard id="monthly-hours" title="Monthly Accumulated" subtitle="Current calendar month" value={fmtHours(stats.monthHours)} accent="amber" Icon={ICONS["monthly-hours"]} />
      <KpiCard id="monthly-earnings" title="Monthly Total Earnings" subtitle="Estimated gross payout" value={fmtMoney(stats.monthEarnings, currency)} accent="emerald" Icon={ICONS["monthly-earnings"]} />
    </div>
  );
}
